module.exports = __webpack_public_path__ + "static/media/LayoutImportacaoParticipantes.ff3b1e6d.xlsx";